import styled from "styled-components";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { BackgroundStyle } from "./types.js";

const selectBackground = ({ backgroundStyle, theme }: { backgroundStyle?: BackgroundStyle; theme: styled.DefaultTheme }) => {
    switch (backgroundStyle) {
        case "blue":
            return theme.gradients.blueToPurple;
        case "legacy":
            return theme.grayscale[20];
        case "white":
            return theme.grayscale.white;
        case "transparent":
            return "transparent";
        default:
            return theme.colors.primary[10];
    }
};

export const LoadingPageContainer = styled(Flex)<{
    display?: boolean;
    backgroundStyle?: BackgroundStyle;
}>`
    height: 100%;
    width: 100%;
    position: absolute;
    display: ${({ display }) => (display ? "flex" : "none")};
    background: ${selectBackground};
    z-index: 1000;
`;
